jQuery(function ($) {

  // Change captions depending on image orientation


  // On Load
  $(window).on('load resize', function () {
    $(".slides li div img").each(function() {
          if( $(this).width() > $(this).height() ) {
            // landscape
            $(this).closest('.slide-inner').addClass('aspect-landscape');
          }
          else if ( $(this).width() < $(this).height() ) {
            // portrait
            $(this).closest('.slide-inner').addClass('aspect-portrait');
          }
          else {
            //square
            $(this).closest('.slide-inner').addClass('aspect-square');
          }
      }); // end each
});




  // Project section navigation
  $(document).ready(function() {
     $(".project-button").click(function(){
       var id = $(this).attr("id");

       // Toggle sections
       $(".project-wrapper > section").removeClass("visible");
       $(".project-wrapper > section." + id).addClass("visible");

       // Check if slideshow and adjust navbar width
       if ( $('.project-slideshow').hasClass('visible') ) {
         $('.navbar-wrapper').removeClass('navbar-crop');
       }
       else {
         $('.navbar-wrapper').addClass('navbar-crop');

         // init Masonry
         var $grid = $('.gallery').masonry({
           itemSelector: '.gallery-item',
           columnWidth: 10
         });
         // layout Masonry after each image loads
         $grid.imagesLoaded().progress( function() {
           console.log('IMAGES LOADED');
           $grid.masonry('layout');
         });

       }

     });
  });



  // Project Gallery Thumbnail Click
  $(document).ready(function() {

    // Set variable from PHP
    var projectDuration = parseInt(slideDuration);

    // Count images and assign rel values
    var startID = -1;
      $('.project-gallery img').each(function() {
          startID++;
          $(this).attr('rel', startID);
      });

    $('.flexslider').flexslider({
      animationSpeed: 0,
      slideToStart: 0,
      slideshowSpeed: projectDuration,
      directionNav: false,
      controlsContainer: ".slide-control-wrapper",
      start: function(slider) {
          $('.project-gallery img').click(function() {
              $('.project-wrapper section').removeClass('visible');
              $('.project-slideshow').addClass('visible');

              var slideTo = $(this).attr("rel")//Grab rel value from link;
              var slideToInt = parseInt(slideTo)//Make sure that this value is an integer;
              if (slider.currentSlide != slideToInt) {
                  slider.flexAnimate(slideToInt)//move the slider to the correct slide (Unless the slider is also already showing the slide we want);
                  // console.log('Rel is: '+ slideTo);
              }
              // Check if sldieshow and adjust navbar width
              if ( $('.project-slideshow').hasClass('visible') ) {
                $('.navbar-wrapper').removeClass('navbar-crop');
              }
              else { $('.navbar-wrapper').addClass('navbar-crop'); }
            });
          }//start
    }); // flexslider master
}); //window load


  // Custom Slide Advance
  $(document).ready(function() {

    $('.previous').on('click', function(){
    $('.flexslider').flexslider('prev');
    return false;
    })

    $('.next, .slides').on('click', function(){
        $('.flexslider').flexslider('next');
        return false;
    })
  });


// End Jquery
});
